import React from "react";
import { ImFacebook } from "react-icons/im";
import { IoLogoInstagram } from "react-icons/io";

const Footer = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="">
        <path
          fill="#fefce8"
          fillOpacity="1"
          d="M0,96L60,117.3C120,139,240,181,360,170.7C480,160,600,96,720,96C840,96,960,160,1080,170.7C1200,181,1320,139,1380,117.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
        ></path>
      </svg>
      <footer className="bg-yellow-50 pb-10">
        <h1 className="text-4xl mb-10 text-center">Commalax</h1>
        <div className="grid grid-cols-3 gap-5 md:gap-20 px-10">
          <div className="first col-span-3 md:col-span-1">
            <div className="flex flex-col gap-5">
              <p>
                <span className="italic"> Commalax</span> sources and
                distributes beauty and wellness products from the beauty care
                powerhouse South Korea and all over the world.
              </p>
              <p>FOLLOW US</p>
              <div className="flex gap-2 items-center">
                <ImFacebook className="cursor-pointer text-lg" />
                <IoLogoInstagram className="cursor-pointer text-xl" />
              </div>
            </div>
          </div>
          <div className="second  col-span-3 md:col-span-1">
            <h1 className="font-semibold">BRANDS</h1>
            <div className="mt-5 flex flex-col gap-3">
              <p className="cursor-pointer">CARE:NEL</p>
              <p className="cursor-pointer">innisfree</p>
              <p className="cursor-pointer">JM solution</p>
            </div>
          </div>
          <div className="third  col-span-3 md:col-span-1">
            <h1 className="font-semibold">COMPANY INFO</h1>
            <div className="mt-5 flex flex-col gap-3">
              <p className="cursor-pointer">About us</p>
              <p className="cursor-pointer">Contact us</p>
            </div>
          </div>
        </div>
        <p className="mt-10 pl-10">© 2023, Commalax. </p>
      </footer>
    </>
  );
};

export default Footer;
